import { render } from "./Student.vue?vue&type=template&id=69014956&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"

import "./Student.vue?vue&type=style&index=0&id=69014956&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69014956"]])

export default __exports__